import React, { useEffect, useState } from 'react';
import MenuMain from './MenuMain';
import { Drawer } from '../Plugin';
import { PhoneCall, Logo, Time } from '../../assets/icons';
import Banner from '../../assets/images/Banner.svg';
import { persianDaysArray, persianMonths } from '../../Utils/PersianDaysArray';
import { Button } from '../Shared';
import moment from 'moment-jalaali';
import { useDispatch, useSelector } from 'react-redux';
import { ApiCall } from '../../Redux/Actions/ApiCall';
import { urls, imageUrl } from '../../Utils/url';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import Power from '@material-ui/icons/PowerSettingsNew';

const HeaderMain = props => {

	const dispatch = useDispatch();
	const [image, setImage] = useState(false);
	const [info, setInfo] = useState();
	const isFaNum = useSelector(
		(state) => state.persistedParams.isFaNum
	)
	const isOpenDrawer = useSelector(
		(state) => state.persistedParams.isOpenDrawer
	)
	const token = useSelector((state) => state.auth.token);

	useEffect(() => {
		getBanner();
		getInfo();
	}, [])

	function changeIsFaNum(e) {
		dispatch({
			type: "IS_FA_NUM",
			payload: e
		})
	}

	function closeDrawer() {
		dispatch({
			type: "IS_OPEN_DRAWER",
			payload: false
		})
	}

	function getDay() {
		const day = moment().day();
		const month = moment().jMonth()
		const dayInMonth = moment().format('jDD')
		const year = moment().format('jYYYY')
		const dayName = persianDaysArray[day]
		const monthName = persianMonths[month]
		return `${dayName} ${dayInMonth} ${monthName} ${year}`;
	}

	function getBanner() {
		ApiCall(
			"GET",
			urls.getBanner,
			{},
			"getBanner-->",
			token,
			(res) => {
				console.log('res', res);
				setImage(res.data);
			},
			(err) => {
				console.log('err', err);
			}
		)
	}

	function getInfo() {
		ApiCall(
			"GET",
			urls.getInfo,
			{},
			"getInfo-->",
			token,
			(res) => {
				console.log('resInfo', res);
				setInfo(res.data)
			},
			(err) => {
				console.log('err', err);
			}
		)

	}

	const logout = () => {
		dispatch({
			type: "IS_LOGIN",
			isLogin: false,
			token: null
		})
	}

	return (
		<div>
			<header className="d-flex justify-content-around headerMain">
				<div className="col-1 _lang">
					<Button className={isFaNum ? "_fa_da" : "_fa"} onClick={() => changeIsFaNum(true)}>
						Fa
				</Button>
					<div className='_slash'>/</div>
					<Button className={!isFaNum ? "_en_da" : "_en"} onClick={() => changeIsFaNum(false)}>
						En
				</Button>
				</div>
				<div className='d-flex flex-column text-center col-3 _firstCol'>
					<div style={{ marginRight: '15%' }}>
						<Logo width='9vw' height='7vh' fontSize='medium' />
					</div>
					<time
						className="_time"
					>
						{getDay()}
						<Time className="_icon" height='30px' width="30px" fontSize='large' />
					</time>
				</div>

				<div className="d-flex flex-column col-6"  >
					<AliceCarousel autoPlay infinite={true} autoPlayInterval="5000">
						<img src={imageUrl + image[0]?.src} className='_imageSlider' />
						<img src={imageUrl + image[1]?.src} className='_imageSlider' />
					</AliceCarousel>
				</div>

				<div className='d-flex flex-column _secondCol'>
					<p style={{ marginTop: '-6%', fontSize: '55%' }}>{info?.union.name}</p>
					<p style={{ fontSize: '80%' }}>{info?.store_name}</p>
					<div className='d-flex flex-row justify-content-around' style={{ alignContent: 'center', alignItems: 'end', marginTop: '-5%' }}>
						<p className='_paragraph'><PhoneCall fontSize='small' className='_phoneIcon' />{info?.phone}</p>
						<div style={{ marginTop: '-1%' }}>
							<Button onClick={logout} className="_btn" >
								<Power className="_powerIcon" fontSize='large' />
							</Button>
						</div>
					</div>
				</div>

			</header>
			<Drawer
				direction="_right"
				isOpen={isOpenDrawer}
				closeDrawer={closeDrawer}
			>
				<MenuMain />
			</Drawer>
		</div>
	)

}


export default HeaderMain
